import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createVNode as _createVNode, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "form widget flex container-full-3 py-8 pb-10" }
const _hoisted_3 = { class: "s9_mobile" }
const _hoisted_4 = { class: "grid6 grid-row-gap-1" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "form-field-floating active my-4" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "text-red"
}
const _hoisted_10 = { class: "form-field-floating reactive my-4" }
const _hoisted_11 = {
  key: 1,
  class: "text-red"
}
const _hoisted_12 = { class: "form-field-floating reactive my-4" }
const _hoisted_13 = {
  key: 2,
  class: "text-red"
}
const _hoisted_14 = { class: "form-switch lg mt-6 mb-3" }
const _hoisted_15 = { class: "switch" }
const _hoisted_16 = ["v-model", "checked"]
const _hoisted_17 = { class: "s10_mobile" }
const _hoisted_18 = { class: "custom-upload-size margin-auto flex mb-8" }
const _hoisted_19 = { class: "grid2" }
const _hoisted_20 = {
  class: "form-check-label",
  for: "sexe_M"
}
const _hoisted_21 = { class: "card-check-text" }
const _hoisted_22 = {
  class: "form-check-label",
  for: "sexe_F"
}
const _hoisted_23 = { class: "card-check-text" }
const _hoisted_24 = { class: "form-field-floating reactive my-4" }
const _hoisted_25 = {
  key: 0,
  class: "text-red"
}
const _hoisted_26 = { class: "form-field-floating reactive my-4" }
const _hoisted_27 = {
  key: 1,
  class: "text-red"
}
const _hoisted_28 = { class: "form-field-floating reactive my-4" }
const _hoisted_29 = { class: "form-field-floating reactive my-4" }
const _hoisted_30 = {
  key: 2,
  class: "text-red"
}
const _hoisted_31 = {
  key: 3,
  class: "text-red"
}
const _hoisted_32 = { class: "flex gap-2" }

import { inject, onMounted, reactive, ref, watch  } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';
    import CustomUploadInput from '@/components/CustomUploadInput.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminFormView',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    const BACKEND_URL = inject('BACKEND_URL');
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const startupFormDatas = reactive({ 
        roles: [] as any[],
        admin: undefined
    });
    const AVATARS_LIST = ['user.jpg', 'user1.jpg', 'user2.jpg', 'user3.jpg', 'user4.jpg', 'user5.jpg', 'user6.jpg', 'user7.jpg', 'user8.jpg', 'user9.jpg', 'user10.jpg', 'user11.jpg'];
    const formData = reactive({
        id: null,
        avatar: AVATARS_LIST.length > 0 ? AVATARS_LIST[0] : '',
        role_id: null,
        username: '',
        email: '',
        etat_valide: true,
        photo: null as any,
        photo_preview: '/assets/users/default.png',
        sexe: 'M',
        nom: '',
        prenom: '',
        fonction: '',
        telephone: ''
    });
    const errors = reactive({
        role_id: '',
        username: '',
        email: '',
        nom: '',
        prenom: '',
        telephone: '',
    });

    onMounted(() => {
        const startupFormInfos: any = route.meta.form_datas;
        startupFormDatas.roles = startupFormInfos.roles;
        startupFormDatas.admin = startupFormInfos.admin;
        if (startupFormInfos.admin !== undefined) {
            formData.id = startupFormInfos.admin.id;
            formData.avatar = startupFormInfos.admin.avatar;
            formData.role_id = startupFormInfos.admin.role_id;
            formData.username = startupFormInfos.admin.username;
            formData.email = startupFormInfos.admin.email;
            formData.etat_valide = startupFormInfos.admin.etat_valide;
            if (startupFormInfos.admin.photo_url) {
                formData.photo_preview = startupFormInfos.admin.photo_url;
            }
            formData.sexe = startupFormInfos.admin.sexe;
            formData.nom = startupFormInfos.nom && startupFormInfos.nom != 'null' ? startupFormInfos.nom : '';
            formData.prenom = startupFormInfos.prenom && startupFormInfos.prenom != 'null' ? startupFormInfos.prenom : '';
            formData.fonction = startupFormInfos.fonction && startupFormInfos.fonction != 'null' ? startupFormInfos.fonction : '';
            formData.telephone = startupFormInfos.telephone && startupFormInfos.telephone != 'null' ? startupFormInfos.telephone : '';
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function doSelectAvatar(avatar: string) {
        formData.avatar = avatar;
    }

    function validatePhone(phoneValue: string) {
        // Exemple pour format international commençant par + (ex: +2250700000000)
        const regex = /^\+?[0-9]{8,15}$/;
        return regex.test(phoneValue);
    }

    function validateEmail(emailValue: string) {
        // Exemple pour format international commençant par + (ex: +2250700000000)
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(emailValue);
    }

    function validate() {
        let isValid = true;

        errors.role_id = '';
        if (!formData.role_id) {
            errors.role_id ="Le role est requis";
            isValid = false;
        }

        errors.username = '';
        if (!formData.username) {
            errors.username ="Le nom d'utilisateur est requis";
            isValid = false;
        }

        errors.email = '';
        if (!validateEmail(formData.email)) {
            errors.email ="L'adresse email est invalide";
            isValid = false;
        }

        /*errors.nom = '';
        if (!formData.nom) {
            errors.nom ="Le nom est requis";
            isValid = false;
        }

        errors.prenom = '';
        if (!formData.prenom) {
            errors.prenom ="Le prénom est requis";
            isValid = false;
        }*/

        errors.telephone = '';
        if (formData.telephone && !validatePhone(formData.telephone)) {
            errors.telephone = 'Le téléphone est invalide';
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    function onFileUploaded(uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData.photo_preview = uploadedFile.file_preview;
        formData.photo = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {

            const formToUpload = new FormData();
            if (formData.id != null) {
                formToUpload.append("id", `${formData.id}`);
            }
            formToUpload.append("avatar", formData.avatar);
            formToUpload.append("role_id", `${formData.role_id}`);
            formToUpload.append("username", formData.username);
            formToUpload.append("email", formData.email);
            formToUpload.append("etat_valide", `${formData.etat_valide ? 1 : 0}`);

            if (formData.photo?.file) {
                formToUpload.append("photo", formData.photo.file, formData.photo.name);
            }

            formToUpload.append("sexe", formData.sexe);
            formToUpload.append("nom", formData.nom);
            formToUpload.append("prenom", formData.prenom);
            formToUpload.append("fonction", formData.fonction);
            formToUpload.append("telephone", formData.telephone);

            await axios.post(`/backoffice/admins/save`, formToUpload);
            router.push('/app/admins/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "page-space-40" }, null, -1)),
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _cache[16] || (_cache[16] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
          _createTextVNode("Administrateur / Création "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(AVATARS_LIST, (avatar, index) => {
            return _createElementVNode("div", {
              class: _normalizeClass(["rounded-100 overflow-hidden cursor-pointer item", {'active': formData.avatar == avatar }]),
              onClick: ($event: any) => (doSelectAvatar(avatar)),
              key: 'avatar_' + index
            }, [
              _createElementVNode("img", {
                src: '/assets/users/300w/' + avatar,
                width: "100%"
              }, null, 8, _hoisted_6)
            ], 10, _hoisted_5)
          }), 64))
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "font-semibold my-5" }, [
          _createTextVNode("Connexion "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("select", {
            class: "form-input-select",
            name: "role_id",
            id: "role_id",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.role_id) = $event))
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("option", {
              value: "",
              selected: ""
            }, "Sélectionnez le rôle", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupFormDatas.roles, (role, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: role.id,
                key: 'role_' + index
              }, _toDisplayString(role.libelle), 9, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, formData.role_id]
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("label", { for: "role" }, [
            _createTextVNode("Rôle "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['role_id'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(errors['role_id']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.username) = $event)),
            name: "username",
            id: "username",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.username]
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("label", { for: "username" }, [
            _createTextVNode("Identifiant "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['username'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(errors['username']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: "form-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.email) = $event)),
            name: "email",
            id: "email",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.email]
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("label", { for: "email" }, [
            _createTextVNode("Email "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['email'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(errors['email']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("label", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("input", {
              type: "checkbox",
              name: "etat_valide",
              "v-model": formData.etat_valide,
              checked: formData.etat_valide
            }, null, 8, _hoisted_16),
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "slider round" }, null, -1))
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("h6", { class: "label text-grey-600" }, "Compte actif", -1))
        ])
      ]),
      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "s1_mobile flex-center" }, [
        _createElementVNode("hr", { class: "hr-vertical h-90p" })
      ], -1)),
      _createElementVNode("section", _hoisted_17, [
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "h-20" }, null, -1)),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(CustomUploadInput, {
            id: "photo",
            label: "Photo de profil",
            preview: formData.photo_preview,
            type: "IMAGE",
            onUploaded: onFileUploaded
          }, null, 8, ["preview"])
        ]),
        _cache[31] || (_cache[31] = _createElementVNode("h5", { class: "font-semibold mb-5" }, [
          _createTextVNode("Informations de l'Administrateur "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            class: _normalizeClass(["card-check mb-2", { 'active': formData.sexe == 'M' }])
          }, [
            _createElementVNode("label", _hoisted_20, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "card-check-icon" }, [
                _createElementVNode("img", { src: "/icons/icon-male.svg" })
              ], -1)),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "sexe",
                  id: "sexe_M",
                  value: "M",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.sexe) = $event))
                }, null, 512), [
                  [_vModelRadio, formData.sexe]
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("h6", null, "Je suis un homme", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("span", null, "Masculin", -1))
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["card-check mb-2", { 'active': formData.sexe == 'F' }])
          }, [
            _createElementVNode("label", _hoisted_22, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "card-check-icon" }, [
                _createElementVNode("img", { src: "/icons/icon-female.svg" })
              ], -1)),
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "sexe",
                  id: "sexe_F",
                  value: "F",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.sexe) = $event))
                }, null, 512), [
                  [_vModelRadio, formData.sexe]
                ]),
                _cache[21] || (_cache[21] = _createElementVNode("h6", null, "Je suis une femme", -1)),
                _cache[22] || (_cache[22] = _createElementVNode("span", null, "Féminin", -1))
              ])
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.nom) = $event)),
            name: "nom",
            id: "nom",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.nom]
          ]),
          _cache[24] || (_cache[24] = _createElementVNode("label", { for: "nom" }, "Nom", -1))
        ]),
        (!!errors['nom'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(errors['nom']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.prenom) = $event)),
            name: "prenom",
            id: "prenom",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.prenom]
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("label", { for: "prenom" }, "Prénom", -1))
        ]),
        (!!errors['prenom'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(errors['prenom']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_28, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.fonction) = $event)),
            name: "fonction",
            id: "fonction",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.fonction]
          ]),
          _cache[26] || (_cache[26] = _createElementVNode("label", { for: "fonction" }, "Fonction", -1))
        ]),
        _createElementVNode("div", _hoisted_29, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.telephone) = $event)),
            name: "telephone",
            id: "telephone",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.telephone]
          ]),
          _cache[27] || (_cache[27] = _createElementVNode("label", { for: "telephone" }, "Téléphone", -1))
        ]),
        (!!errors['telephone'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(errors['telephone']), 1))
          : _createCommentVNode("", true),
        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "clear-both h-25" }, null, -1)),
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-xs text-grey-500 mb-5" }, [
          _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
          _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
        ], -1)),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_custom_button, {
            id: "btn-submit",
            type: "button",
            classesList: 'btn lg w-40',
            loading: loading.value,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
              _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Enregistrer", -1)
            ]))]),
            _: 1
          }, 8, ["loading"]),
          _cache[29] || (_cache[29] = _createElementVNode("button", { class: "btn stroke black lg px-10" }, [
            _createElementVNode("span", null, "Effacer")
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})